var firebaseConfig = {
    apiKey: "AIzaSyBKJcF7gQ4MhmIry61Gew0JPBRQsWu7X_g",
    authDomain: "chat-f5a5f.firebaseapp.com",
    databaseURL: "https://chat-f5a5f.firebaseio.com",
    projectId: "chat-f5a5f",
    storageBucket: "chat-f5a5f.appspot.com",
    messagingSenderId: "4537496419",
    appId: "1:4537496419:web:d24ae3a4f88444ef8bd956",
    measurementId: "G-78PPH9SMCW"
  };

  export default firebaseConfig;